import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
} from "react";
import toast from "react-hot-toast";
import { useAuth } from "./Auth-Context";
import { useAxios } from "../customHooks";

const PlaylistContext = createContext();

const PlaylistProvider = ({ children }) => {
  const { encodedToken, user , responseUpdateUserProfile} = useAuth();
  const {
    response: playlistResponse,
    isLoading: playlistLoading,
    operation: playlistOperation,
  } = useAxios();
  const {
    response: playlistVideosResponse,
    isLoading: playlistVideoLoading,
    operation: playlistVideosOperation,
  } = useAxios();
  const { response: allPlaylist, operation: fetchPlaylists } = useAxios();

  const [selectedVideo, setSelectedVideo] = useState({});
  const [createdPlaylists, setCreatedPlaylists] = useState([]);
  const [playlist, setPlaylist] = useState({ name: "", description: "" });

  useEffect(() => {
    if (user && encodedToken) {
      fetchPlaylists({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_API}playlists/u/${user?._id}`,
        headers: { authorization: encodedToken },
      });
    }
  }, [user?._id, encodedToken]);

  useEffect(() =>{
    if(responseUpdateUserProfile != null){
      fetchPlaylists({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_API}playlists/u/${user?._id}`,
        headers: { authorization: encodedToken },
      });
    }
  },[responseUpdateUserProfile])

  useEffect(() => {
    if (allPlaylist) {
      setCreatedPlaylists(allPlaylist?.data);
    }
  }, [allPlaylist]);

  const createPlaylist = (e) => {
    e.preventDefault();
    if (playlist.name.trim() === "" && playlist.description.trim() === "") {
      return alert("Enter all fields...");
    }
    playlistOperation({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_API}playlists/create-playlist`,
      headers: { authorization: encodedToken },
      data: { name: playlist.name, description: playlist.description },
    });
    toast.success("Playlist created Successfully", { duration: 1000 });
  };

  const deletePlaylist = (playlistId) => {
    playlistOperation({
      method: "delete",
      url: `${process.env.REACT_APP_BACKEND_API}playlists/p/${playlistId}`,
      headers: { authorization: encodedToken },
    });
    toast.success("Playlist deleted Successfully", { duration: 1000 });
  };

  const addToPlaylist = (playlistId, video) => {
    playlistVideosOperation({
      method: "patch",
      url: `${process.env.REACT_APP_BACKEND_API}playlists/p/${playlistId}/${video._id}`,
      headers: { authorization: encodedToken },
    });
    toast.success("Video added to playlist Successfully", { duration: 1000 });
  };

  const deleteFromPlaylist = (playlistId, videoId) => {
    playlistVideosOperation({
      method: "delete",
      url: `${process.env.REACT_APP_BACKEND_API}playlists/p/${playlistId}/${videoId}`,
      headers: { authorization: encodedToken },
    });
    toast.success("Video removed from playlist Successfully", {
      duration: 1000,
    });
  };

  useEffect(() => {
    if (playlistResponse !== undefined) {
      setCreatedPlaylists(playlistResponse.data);
      setPlaylist({ name: "", description: "" });
    }
  }, [playlistResponse]);

  useEffect(() => {
    if (playlistVideosResponse !== undefined) {
      setCreatedPlaylists(playlistVideosResponse.data);
    }
  }, [playlistVideosResponse]);

  const memoizedContextValue = useMemo(
    () => ({
      createPlaylist,
      setPlaylist,
      playlist,
      createdPlaylists,
      playlistLoading,
      selectedVideo,
      playlistVideoLoading,
      deletePlaylist,
      addToPlaylist,
      setSelectedVideo,
      deleteFromPlaylist,
    }),
    [
      createPlaylist,
      setPlaylist,
      playlist,
      createdPlaylists,
      playlistLoading,
      selectedVideo,
      playlistVideoLoading,
      deletePlaylist,
      addToPlaylist,
      setSelectedVideo,
      deleteFromPlaylist,
    ]
  );
  return (
    <PlaylistContext.Provider value={memoizedContextValue}>
      {children}
    </PlaylistContext.Provider>
  );
};

const usePlaylist = () => useContext(PlaylistContext);

export { PlaylistProvider, usePlaylist };
